import getProfileStore from '../store/profileStore';

export function getAccountIdByEmailAddress(email: string): string {
    const accounts = getProfileStore().accountSources.filter(
        account => account.mailbox?.emailAddress === email
    );

    if (accounts.length > 1) {
        throw new Error(
            'Found ' + accounts.length + ' duplicated accounts with same email address: ' + email
        );
    } else if (accounts.length === 1) {
        return accounts[0].id;
    } else {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (18,9): Type 'null' is not assignable to type 'string'.
        // @ts-ignore
        return null;
    }
}
